module.exports = __webpack_public_path__ + "b33294b694801532efcd5c5c0d8b7704.svg";